import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["layer"]

  connect() {
    this.motion = matchMedia("(prefers-reduced-motion: no-preference) and (hover: hover) and (pointer: fine)")
    this.onMotion = () => {
      cancelAnimationFrame(this.frameId)
      this.frameId = null
      this.pointer = this.eased = { x: 0, y: 0 }
      this.layerTargets.forEach(layer => layer.removeAttribute("transform"))
    }
    this.onMotion()
    this.motion.addEventListener("change", this.onMotion)
  }

  disconnect() {
    cancelAnimationFrame(this.frameId)
    this.motion.removeEventListener("change", this.onMotion)
  }

  move(event) {
    if (!this.motion.matches || event.pointerType !== "mouse") return
    const bounds = this.element.getBoundingClientRect()
    const clamp = value => Math.max(-1, Math.min(1, value))
    this.pointer = { x: clamp((event.clientX - bounds.left) / bounds.width * 2 - 1),
      y: clamp((event.clientY - bounds.top) / bounds.height * 2 - 1) }
    this.start()
  }

  reset() {
    this.pointer = { x: 0, y: 0 }
    this.start()
  }

  start() {
    if (this.motion.matches && !this.frameId) this.frameId = requestAnimationFrame(() => this.frame())
  }

  frame() {
    this.frameId = null
    this.eased.x += (this.pointer.x - this.eased.x) * .08
    this.eased.y += (this.pointer.y - this.eased.y) * .08
    const settled = Math.abs(this.pointer.x - this.eased.x) + Math.abs(this.pointer.y - this.eased.y) < .001
    if (settled) this.eased = { ...this.pointer }
    this.layerTargets.forEach(layer => {
      const depth = Number(layer.dataset.depth)
      layer.setAttribute("transform", `translate(${this.eased.x * depth} ${this.eased.y * depth})`)
    })
    if (!settled) this.start()
  }
}
